import {
    AfterViewChecked,
    Component,
    ElementRef,
    EventEmitter,
    Input,
    OnDestroy,
    OnInit,
    Output,
    ViewChild,
    ViewEncapsulation,
} from "@angular/core";
import { FormlyFieldConfig, FormlyFormOptions } from "@ngx-formly/core";
import { FormCollectModel } from "./form-collect.model";
import { Subject } from "rxjs";
import { BuilderService } from "../builder/builder.service";
import { FormGroup } from "@angular/forms";
import { fixInputSpacing } from "../formly/helpers";

export class FormExtraAction {
    id: number;
    text: string;
}

@Component({
    selector: "form-collect",
    templateUrl: "./form-collect.component.html",
    encapsulation: ViewEncapsulation.None,
})
export class FormCollectComponent implements OnInit, OnDestroy, AfterViewChecked {
    private _unsubscribeAll: Subject<any> = new Subject<any>();

    formViewModel: FormCollectModel;

    @Input()
    set formModel(model: FormCollectModel) {
        this.formViewModel = model;
        this.fields = model.fields;
        this.model = model.value;
    }

    @Input()
    loading: boolean = false;

    @Output()
    onSave: EventEmitter<string> = new EventEmitter<string>();

    @Output()
    onExtraAction: EventEmitter<any> = new EventEmitter<any>();

    @Output()
    onCancel: EventEmitter<boolean> = new EventEmitter<boolean>();

    @Input()
    standalone: boolean;

    @Input()
    definition: string;

    @Input()
    value: any = {};

    @Input()
    bottomActions: FormExtraAction[] = [];

    @Input()
    v2: boolean = false;

    form = new FormGroup({});

    model: any = {};

    options: FormlyFormOptions = {};

    fields: FormlyFieldConfig[] = [];

    formModelChanged = false;

    @ViewChild("formlyFormContainer") formlyFormContainerRef: ElementRef<HTMLDivElement>;

    constructor(private _builderService: BuilderService) {}

    ngOnInit(): void {
        const jsonDefinition: string = this.definition;
        const formDefinition = this._builderService.fromJson(this.definition);
        const model = new FormCollectModel();
        let fields = formDefinition.isVForm
            ? this._builderService.toFormlyFields(formDefinition)
            : JSON.parse(jsonDefinition).fields;
        this.fixFieldType(fields);
        model.fields = fields;
        model.title = formDefinition.title;
        model.description = formDefinition.description;
        for (let field of fields) {
            // If it's a checkbox, do a boolean conversion to prevent "False" string to being considered as true
            if (field.type === "checkbox") {
                this.value[field.key] = this.value[field.key]?.toLowerCase() === "true";
            }
        }
        model.value = this.value;
        this.formModel = model;
        this.formModelChanged = true;
    }

    ngAfterViewChecked() {
        // only execute when model changed and for views updated with new data
        if (!this.formModelChanged) return;
        this.formModelChanged = false;

        this.fixSpacing();
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    get formErrors(): string[] {
        if (!this.form.errors) {
            return [];
        }
        return Object.keys(this.form.errors);
    }

    getErrorMessage(error: string) {
        switch (error) {
            case "dateOrder":
                return "DUM deve ser anterior à DPP.";
            default:
                return "";
        }
    }

    fixFieldType(fields: any) {
        for (let field of fields) {
            if (field.fieldGroup) {
                this.fixFieldType(field.fieldGroup);
            } else if (field.fieldArray) {
                this.fixFieldType(field.fieldArray.fieldGroup);
            } else if (field.type === "input" && field.templateOptions?.type === "date") {
                field.type = "datepicker";
            } else if (field.type === "input" && field.templateOptions?.type === "time") {
                field.type = "timepicker";
            }
        }
    }

    fixSpacing() {
        if (!!this.formlyFormContainerRef?.nativeElement) {
            fixInputSpacing(this.formlyFormContainerRef.nativeElement);
        }
    }

    save() {
        if (!this.form.valid) {
            this.form.markAllAsTouched();
            return;
        }
        const definition = JSON.stringify(this.model);
        this.onSave.emit(definition);
    }

    close() {
        this.onCancel.emit(true);
    }

    dispatchExtraAction(actionId) {
        if (!this.form.valid) {
            this.form.markAllAsTouched();
            return;
        }
        const definition = JSON.stringify(this.model);
        this.onExtraAction.emit({
            actionId: actionId,
            data: definition,
        });
    }

    onModelChange(event) {
        let model = event;
        this.fields.forEach((field) => {
            if (field.templateOptions.disabled) {
                field.formControl.setValue(undefined);
                delete model[`${field.key}`];
            }
        });
        this.model = model;
    }
}
